var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PDF',_vm._g(_vm._b({attrs:{"pdf":_vm.pdf,"page":_vm.page,"pages":_vm.pages,"showAllPages":_vm.showAllPages}},'PDF',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }